/**
 * Public header and footer links. Shared by components/layout/PublicShell
 * and scripts/prerender.mjs so the static HTML frame and the React frame
 * are identical (no jump when the app takes over).
 */
export const PUBLIC_NAV = [
  { label: "Find a specialist", to: "/directory" },
  { label: "Conditions", to: "/conditions" },
  { label: "Referrals & costs", to: "/guide/seeing-a-specialist" },
  { label: "Brief", to: "/brief" },
  { label: "Access Report", to: "/access-report" },
] as const;

export const FOOTER_COLUMNS = [
  {
    heading: "Patients",
    links: [
      { label: "Find a specialist", to: "/directory" },
      { label: "Which specialist do I need?", to: "/conditions" },
      { label: "Referrals, Medicare and costs", to: "/guide/seeing-a-specialist" },
    ],
  },
  {
    heading: "Clinicians",
    links: [
      { label: "Canberra Referral Brief", to: "/brief" },
      { label: "Public health alerts", to: "/alerts" },
      { label: "Clinician sign in", to: "/board" },
    ],
  },
  {
    heading: "PulseBoard",
    links: [
      { label: "Access Report", to: "/access-report" },
      { label: "Join", to: "/join" },
      { label: "Privacy", to: "/privacy" },
      { label: "Terms", to: "/terms" },
    ],
  },
] as const;

export function isCurrentNavPath(pathname: string, route: string): boolean {
  if (route === "/directory") return pathname.startsWith("/directory");
  return pathname === route || pathname.startsWith(`${route}/`);
}
